import { library } from "@fortawesome/fontawesome-svg-core";
import { faCircleCheck, faCopy, faCircleXmark,
// faRotate,
 } from "@fortawesome/free-regular-svg-icons";
import { faChevronDown, faChevronUp, faChevronLeft, faChevronRight, faCircleInfo, faEye, faEyeSlash, faMagnifyingGlass, faUser, faHouse, faRotate, faSignOut, faQuestionCircle, } from "@fortawesome/free-solid-svg-icons";
library.add(faCopy, faCircleCheck, faCircleXmark, faChevronDown, faChevronUp, faCircleInfo, faEye, faEyeSlash, faMagnifyingGlass, faUser, faHouse, faChevronLeft, faChevronRight, faRotate, faSignOut, faQuestionCircle);
